import { useDboParams } from 'features/db-optimization/v2/hooks/useDboParams';
import { useInstances } from 'features/db-optimization/v2/hooks/useInstances';
import {
  isInstanceOptimized,
  toInstanceModelV2,
} from 'features/db-optimization/v2/utils/instanceToViewV2';
import { DEMO_INSTANCES } from 'features/db-optimization/v2/demo/demoInstances';
import { useMemo } from 'react';

export const useDboSidebarV2 = () => {
  const { dbServerId } = useDboParams();
  const {
    data,
    isFetching: loadingServers,
    error: loadingServersError,
  } = useInstances();

  const allInstances = useMemo(() => {
    const real = [...(data?.optimized ?? []), ...(data?.other ?? [])];
    // Demo instances are served on demand by the mock store and never appear
    // in the real instance list — append the one being viewed so the sidebar
    // reflects the current route.
    if (!dbServerId || real.some(({ id }) => id === dbServerId)) return real;
    const demo = DEMO_INSTANCES.find((i) => i.id === dbServerId);
    return demo ? [...real, toInstanceModelV2(demo)] : real;
  }, [data, dbServerId]);

  const activeServer = useMemo(() => {
    if (!allInstances.length || !dbServerId) {
      return undefined;
    }
    return allInstances.find(({ id }) => id === dbServerId);
  }, [dbServerId, allInstances]);

  const isOptimized = isInstanceOptimized(activeServer?.features);

  return {
    loadingServers,
    loadingServersError,
    activeServer,
    allInstances,
    isOptimized,
  };
};
